
function About(props) {
    return (
            <div className="accordion container" id="accordionExample" style={{ color : props.mode==="dark" ? "white" : "black"}}>
                <h2 className="my-3">About Us</h2>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius incidunt ipsum asperiores quasi! Natus sint eius et modi ipsum nihil atque tenetur accusantium accusamus, ipsam voluptatibus? Omnis, sapiente reprehenderit aliquid nostrum recusandae asperiores expedita. Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt tenetur officiis atque sapiente recusandae. Dolorum assumenda blanditiis, quasi asperiores iste id officia eaque? Et cum veritatis unde quos accusantium. Dolor?Lorem ipsum dolor sit, amet consectetur adipisicing elit. Molestias labore maxime ad dicta itaque veniam, tenetur beatae fugiat eius officiis magni consectetur tempore commodi accusamus, maiores sed culpa aliquam? Praesentium.</p>
            </div>
    )
}

export default About
